module.exports = __webpack_public_path__ + "img/timer.1f91d15a.svg";